import { lightProfileConstants as lpc } from './constants'
import { profileService } from 'srcReact/services'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export const lightProfileActions = {
  getUserLightProfile,
  loadMoreGroups,
  loadMoreMixrs,
  clearData,
  openLightProfileModal,
  closeLightProfileModal
}

function getUserLightProfile(payload) {
  return (dispatch) => {
    dispatch(request(payload))

    profileService.getProfileDetails(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: lpc.GET_LIGHT_PROFILE_REQUEST, response }
  }
  function success(response) {
    return { type: lpc.GET_LIGHT_PROFILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: lpc.GET_LIGHT_PROFILE_FAILURE, error }
  }
}

function loadMoreGroups(payload, pagination) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination, payload.groupType))

    profileService
      .getProfileDetails({
        ...payload,
        ...(payload.groupType === 'expertise'
          ? {
              expertise_groups_for_light_quantity: appConstantSettings.PAGINATION_QUANTITY,
              expertise_groups_for_light_offset: nextOffset
            }
          : {
              interest_groups_for_light_quantity: appConstantSettings.PAGINATION_QUANTITY,
              interest_groups_for_light_offset: nextOffset
            })
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(isPagination, groupType) {
    return { type: lpc.LOAD_MORE_GROUPS_REQUEST, isPagination, groupType }
  }
  function success(response) {
    const updatedResponse = { ...response, isPagination, groupType: payload.groupType }
    return { type: lpc.LOAD_MORE_GROUPS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: lpc.LOAD_MORE_GROUPS_FAILURE, error }
  }
}

function loadMoreMixrs(payload, pagination) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(pagination))

    profileService
      .getProfileDetails({
        ...payload,
        mixrs_for_light_quantity: appConstantSettings.PAGINATION_QUANTITY,
        mixrs_for_light_offset: nextOffset
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: lpc.LOAD_MORE_MIXRS_REQUEST, response }
  }
  function success(response) {
    const updatedResponse = { ...response, isPagination }
    return { type: lpc.LOAD_MORE_MIXRS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: lpc.LOAD_MORE_MIXRS_FAILURE, error }
  }
}

function clearData() {
  return { type: lpc.CLEAR_DATA }
}

function openLightProfileModal(data) {
  return { type: lpc.OPEN_MODAL, user: data }
}

function closeLightProfileModal() {
  return { type: lpc.CLOSE_MODAL }
}
